<template>
    <div :id="this.id" @contextmenu.prevent="handler($event)"
         class="sitebuilder-element-container"
         element="MailingBossFormComponent"
         :data-tag="dataTag()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
          :style="style()">


        <!--      <div class="divBlock" v-show="!this.preview"></div>-->
        <form :class="horizontal ? 'form-mboss horizontal-form': 'form-mboss'" :target="internal_config.target"
              method="post" ref="form"
              :action="'https://member.mailingboss.com/index.php/lists/'+internal_config.listUid+'/subscribe'">
            <div class="inputs-area" ref="container"></div>
            <div class="place-btn">
                <div class="bt-sb"
                     v-bind:style="{
                        width : buttonWidth,
                        border : buttonBorder,
                        'border-radius': buttonRadius,
                        background: buttonBackground,
                        'box-shadow': buttonBoxShadow
                        }">
                    <div style="cursor: pointer" class="bt-text-area">
                        <a v-on:click="submit($event)" class="btn sb-text"
                           :style="textStyle()">{{internal_config.button.text}}</a>
                        <br :v-show="this.internal_config.button.subtext != ''"/>
                        <small class="btn sb-sub-text" v-show="this.internal_config.button.subtext != ''"
                               :style="subTextStyle()">{{internal_config.button.subtext}}</small>
                    </div>
                </div>
            </div>
        </form>


        <sweet-modal ref="modal" width="30vw">
            <div class="list-group-mailing-boss list-group"></div>
            <!--        <div v-for="(element,index) in this.internal_config.dataList" :key="index" class="item-icon show"-->
            <!--             :data-name="element.general.name">-->
            <!--          <span>{{element.general.name}}</span>-->
            <!--        </div>-->
            <button slot="button" class="btn btn-outline-info" @click="close">Cancel</button>
            <button slot="button" class="btn btn-outline-success" @click="selectList">Select</button>
        </sweet-modal>

    </div>
</template>

<script>

	import Vue from 'vue';
	import Data from './Model';
	import Resources from './Resources.vue';
	import {SweetModal} from 'sweet-modal-vue'

	import CheckFields from "../Fields/CheckFields.vue";
	import SelectFields from "../Fields/SelectFields.vue";
	import TextFields from "../Fields/Text.vue";
	import DateFields from "../Fields/DateFields.vue";

	export default {
		name: 'MailingBossFormComponent',
		props: ['config', 'id', 'preview'],
		components: {
			Data,
			Resources,
			SweetModal,
			CheckFields,
			SelectFields,
			TextFields,
			DateFields
		},
		computed: {
			horizontal() {
				return this.internal_config.horizontal;
			},
			buttonWidth() {
				return parseInt(this.internal_config.button.width) + '%';
			},
			buttonBorder() {
				return this.internal_config.button.border;
			},
			buttonBoxShadow() {
				return this.internal_config.button.boxShadow;
			},
			buttonRadius() {
				return this.internal_config.button.borderRadius;
			},
			buttonBackground() {
				let bg = this.internal_config.button.backgroundColor;

				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					bg += ' url("' + this.internal_config.button.backgroundImage + '")';
					bg += ' ' + this.internal_config.button.backgroundPosition;
					bg += ' / ' + this.internal_config.button.backgroundSize;
					bg += ' ' + this.internal_config.button.backgroundRepeat;
					bg += ' ' + this.internal_config.button.backgroundOrigin;
				}

				return bg;
			}
		},
		data() {
			return Data.data();
		},
		methods: {
			dataTag(){
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},

			submit(e) {

				if(typeof __baCRMTracking !== 'undefined') {
					__baCRMTracking.onSubmit(e)
				}
				this.$refs.form.submit();
			},

			close() {
				if (this.internal_config.listUid === '') {
					// $(this.$el).detach();
				}
				this.$refs.modal.close();
			},
			buildFields: function (vm) {

				this.$refs.container.innerHTML = '';

				vm.internal_config.dataList.forEach(field => {
					const {identifier} = field.type;
					if (identifier === 'textarea') vm.createTextField(field, true);
					if (identifier === 'text') vm.createTextField(field, false);
					if (identifier === 'multiselect') vm.createDropDown(field, true);
					if (identifier === 'dropdown') vm.createDropDown(field, false);
					if (identifier === 'datetime') vm.createDateTime(field, true);
					if (identifier === 'date') vm.createDateTime(field, false);
					if (identifier === 'checkbox') vm.createCheckField(field, 'checkbox');
					if (identifier === 'radio') vm.createCheckField(field, 'radio');
				});
				// let element = document.querySelectorAll('body');
				// element.classList.remove("loading");
			},
			selectList() {
				//
				// let vm = this;
				//
				// let dataRef = $('.list-group-item.selected').attr('data-ref');
				// this.internal_config.listUid = dataRef;
				//
				// this.getFields(dataRef, vm);
				// vm.close();
			}
			,


			textStyle() {
				return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
			},

			subTextStyle() {
				return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
			}
			,
			buildIcon: function () {

				$(this.$el).find('i').detach();

				if (this.internal_config.button.icon !== '') {
					if (this.internal_config.button.iconPosition === 'left') {
						$('<i>').addClass('mdi ' + this.internal_config.button.icon).prependTo($(this.$el).find('.sb-text').get(0));
					}
					if (this.internal_config.button.iconPosition === 'right') {
						$('<i>').addClass('mdi ' + this.internal_config.button.icon).appendTo($(this.$el).find('.sb-text').get(0));
					}
				}
			}
			,
			build(config) {
				this.internal_config = config;

				this.buildIcon();
			}
			,
			style() {
				return `left:  ${this.internal_config.left};
						padding-top: ${this.internal_config.paddingTop};
						  width: ${this.internal_config.width};
                     z-index: ${this.internal_config.zIndex};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
			}
			,
			styleResize() {
				return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
			}
			,
			handler: function (e) {
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			}
			,

			createCheckField(field, type) {
				let ComponentClass = Vue.extend(CheckFields);
				let instance = new ComponentClass({
					propsData: {
						type: type,
						label: field.label,
						options: field.options,
						showLabel: true,
						showPlaceholder: this.internal_config.showPlaceholder,
						selected: [],
						data: field,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			}
			,
			createDropDown(field, multiple) {

				let ComponentClass = Vue.extend(SelectFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						options: field.options,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						selected: [],
						data: field,
						multiple: multiple,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			}
			,
			createDateTime(field, useCurrent) {

				let ComponentClass = Vue.extend(DateFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						data: field,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						value: new Date().toString(),
						type: (useCurrent ? 'datetime' : 'date'),
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			}
			,
			createTextField(field, area) {
				let ComponentClass = Vue.extend(TextFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						value: '',
						data: field,
						area: area,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			}
			,
			inputStyle() {

				let vm = this;

				let elements = this.$el.getElementsByClassName('form-control');
				[].forEach.call(elements, function (el) {
					el.style.backgroundColor = vm.internal_config.inputColor;
					el.style.border = vm.internal_config.inputBorder;
					el.style.height = vm.internal_config.inputHeight;
					el.style.borderRadius = vm.internal_config.inputRadius;

					el.style.fontFamily = vm.internal_config.inputStyle.family;
					el.style.fontSize = vm.internal_config.inputStyle.size;
					el.style.textAlign = vm.internal_config.inputStyle.align;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.color = vm.internal_config.inputStyle.color;
				});
			}
			,
		},

		mounted() {

			let vm = this;

			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');


			// if (this.$props.preview) {
				this.$el.classList.add('preview');

				this.$el.addEventListener('mouseover', function () {
					document.body.style.setProperty('--button-background-color--hover', vm.internal_config.button.backgroundColorHover);
				});
			// }


			if (this.internal_config.listUid === '') {
				this.listsOfUser();
			} else {
				this.buildFields(this);
			}

			this.inputStyle();
		},
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .sitebuilder-element-container .vdr,
    .vdr, .bt-sb,
    form.form-mboss {
        height: auto !important;
    }

    .place-btn {
        text-align: center;

        .bt-sb {
            display: inline-block;
        }
    }

    .bt-text-area {
        display: block;
    }

    [data-device="mobile"] .bt-text-area {
        width: auto !important;
    }

    .horizontal-form {
        display: flex;

        .inputs-area {
            width: 50%;
        }

        .place-btn {
            width: 50%;
            position: relative;

            .bt-sb {
                position: absolute;
                bottom: 15px;
                left: 0;
            }
        }
    }
</style>
<style lang="scss">

    select.form-control[multiple], select.form-control[size],
    textarea.form-control {
        height: auto !important;
    }

    .list-item {
        display: block;
        width: 100%;
        border: 1px solid lightgrey;
        border-radius: 5px;
        margin-top: 2px;
        cursor: pointer;
    }

    .list-item.selected {
        border: 1px solid blue;
    }
</style>
